import {put, call, takeLatest, select} from 'redux-saga/effects';
import ReviewsApi from '../api/reviews.api';
import * as ActionTypes from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';

function* submitReview(action) {
  try {
    const storeToken = yield select(state => state.auth);
    const headers = getBearerHeader(null, storeToken);
    if (!headers) {
      yield put({type: ActionTypes.ERROR_REQUIRE_LOGIN});
      return;
    }

    const variables = {
      itemId: action.itemId,
      rating: action.rating,
      body: action.comment,
      authorId: storeToken.c_account,
      authorName: storeToken.display_name,
    };

    const result = yield call(ReviewsApi.submitReview, variables, headers);
    if (result && result.errors && result.errors.length > 0) {
      yield put({
        type: ActionTypes.SUBMIT_REVIEW_FAILED,
        message: result.errors[0].message,
      });
    } else {
      yield put({type: ActionTypes.SUBMIT_REVIEW_SUCCESS, result});
    }
  } catch (e) {
    yield put({type: ActionTypes.SUBMIT_REVIEW_FAILED, message: e.message});
  }
}

export default function* reviewsSaga() {
  yield takeLatest(ActionTypes.SUBMIT_REVIEW_REQUESTED, submitReview);
}
